<div class="content-container">
  <ul class="flex flex-wrap justify-center md:grid md:grid-cols-2 gap-5">
    <app-info-card *ngFor="let card of cards" [card]="card"></app-info-card>
  </ul>
</div>
